import { REGISTRATION_EVENTS } from '../config/event-registration-config';

function getEventDateMs(event) {
  if (!event?.date) return NaN;
  const parsed = new Date(event.date);
  if (Number.isNaN(parsed.getTime())) return NaN;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate()).getTime();
}

/** Split registration keys into upcoming vs past by event date (local midnight). */
export function partitionRegistrationKeys(keys) {
  const today = new Date();
  const todayMs = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  ).getTime();

  const upcoming = [];
  const past = [];

  for (const key of keys) {
    const event = REGISTRATION_EVENTS[key];
    if (!event) continue;
    const eventMs = getEventDateMs(event);
    if (!Number.isNaN(eventMs) && eventMs < todayMs) {
      past.push(key);
    } else {
      upcoming.push(key);
    }
  }

  return { upcoming, past };
}
